var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 31,
    viewBox: "0 0 56 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 0H1.75C0.783453 0 0 0.771017 0 1.72222V29.2778C0 30.229 0.783453 31 1.75 31H54.25C55.2165 31 56 30.229 56 29.2778V1.72222C56 0.771017 55.2165 0 54.25 0ZM52.5 27.5556H3.5V3.44444H52.5V27.5556Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7143 24H38.2857C39.2325 24 40 23.3285 40 22.5C40 21.6715 39.2325 21 38.2857 21H17.7143C16.7675 21 16 21.6715 16 22.5C16 23.3285 16.7675 24 17.7143 24Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6667 24H47.3333C48.2539 24 49 23.3285 49 22.5C49 21.6715 48.2539 21 47.3333 21H45.6667C44.7461 21 44 21.6715 44 22.5C44 23.3285 44.7461 24 45.6667 24Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 24H10.3333C11.2539 24 12 23.3285 12 22.5C12 21.6715 11.2539 21 10.3333 21H8.66667C7.74615 21 7 21.6715 7 22.5C7 23.3285 7.74615 24 8.66667 24Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17C25.3284 17 26 16.3284 26 15.5C26 14.6716 25.3284 14 24.5 14C23.6716 14 23 14.6716 23 15.5C23 16.3284 23.6716 17 24.5 17Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C19.1046 17 20 16.3284 20 15.5C20 14.6716 19.1046 14 18 14C16.8954 14 16 14.6716 16 15.5C16 16.3284 16.8954 17 18 17Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17C11.1046 17 12 16.3284 12 15.5C12 14.6716 11.1046 14 10 14C8.89543 14 8 14.6716 8 15.5C8 16.3284 8.89543 17 10 17Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17C32.3284 17 33 16.3284 33 15.5C33 14.6716 32.3284 14 31.5 14C30.6716 14 30 14.6716 30 15.5C30 16.3284 30.6716 17 31.5 17Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38 17C39.1046 17 40 16.3284 40 15.5C40 14.6716 39.1046 14 38 14C36.8954 14 36 14.6716 36 15.5C36 16.3284 36.8954 17 38 17Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 17C47.1046 17 48 16.3284 48 15.5C48 14.6716 47.1046 14 46 14C44.8954 14 44 14.6716 44 15.5C44 16.3284 44.8954 17 46 17Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10C25.3284 10 26 9.32843 26 8.5C26 7.67157 25.3284 7 24.5 7C23.6716 7 23 7.67157 23 8.5C23 9.32843 23.6716 10 24.5 10Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C19.1046 10 20 9.32843 20 8.5C20 7.67157 19.1046 7 18 7C16.8954 7 16 7.67157 16 8.5C16 9.32843 16.8954 10 18 10Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C11.1046 10 12 9.32843 12 8.5C12 7.67157 11.1046 7 10 7C8.89543 7 8 7.67157 8 8.5C8 9.32843 8.89543 10 10 10Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10C32.3284 10 33 9.32843 33 8.5C33 7.67157 32.3284 7 31.5 7C30.6716 7 30 7.67157 30 8.5C30 9.32843 30.6716 10 31.5 10Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10C39.1046 10 40 9.32843 40 8.5C40 7.67157 39.1046 7 38 7C36.8954 7 36 7.67157 36 8.5C36 9.32843 36.8954 10 38 10Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10C47.1046 10 48 9.32843 48 8.5C48 7.67157 47.1046 7 46 7C44.8954 7 44 7.67157 44 8.5C44 9.32843 44.8954 10 46 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardIcon);
export default __webpack_public_path__ + "static/media/keyboardIcon.14f4da96f51492280ac7354cf9e0716c.svg";
export { ForwardRef as ReactComponent };